import { useTranslation } from 'next-i18next'
import { Fragment, ReactNode } from 'react'

import MediaPageWrapperNav from './MediaPageWrapperNav/MediaPageWrapperNav'
import { NavigationElement } from './MediaPageWrapperNav/MediaPageWrapperNav.types'

export default function MediaPageWrapper({
  activeNavElement,
  children,
}: {
  activeNavElement: NavigationElement
  children: ReactNode
}): React.ReactElement {
  const { t } = useTranslation('media')

  return (
    <div className="text-black-light">
      <h1 className="mb-1 text-center text-h3 xl:text-h1">{t('title')}</h1>
      <MediaPageWrapperNav activeNavElement={activeNavElement} />
      <Fragment>{children}</Fragment>
    </div>
  )
}
